import StorageService from "../session/storage.service";
import StorageType from "../session/storage.enum";
import AppSetting from "../../common/constants/appsetting.constant";
import axios from "axios";
import moment from "moment";

const TranscriptsService = {
  loggedInUserData: {},
  findAppointmentData: {},
  isFromAddAppointment: false,

  getLoggedInData() {
    return JSON.parse(StorageService.get('session', "userDetails")
    );
  },


  /**
   * GET a presigned S3 PUT URL + jobName
   * AppSetting.transcripts.getUploadUrl must be like:
   *   /providers/{providerId}/patients/{patientId}/getuploadurl
   */
  async getUploadUrl(patientId) {
    const providerId = this.getLoggedInData()['parentId'];
    const url = AppSetting.transcripts.getUploadUrl
      .replace('{providerId}', providerId)
      .replace('{patientId}', patientId);

        return axios.get(url)
        .then(res=>{
            return res.data
        })
        .catch(err=>{
            throw err
        })


  },

  /**
   * POST to start the HealthScribe job for a given jobName
   * AppSetting.transcripts.startMedicalScribeJob must be like:
   *   /providers/{providerId}/patients/{patientId}/startmedicalscribejob
   */
  async startMedicalScribeJob(patientId, jobName) {
    const providerId = this.getLoggedInData()['parentId'];
    const url = AppSetting.transcripts.startMedicalScribeJob
      .replace('{providerId}', providerId)
      .replace('{patientId}', patientId);

    return axios.post(url, {
      "jobName": jobName
      })
      .then((a) => { 
        return a 
      })
      .catch(err => { 
        throw err 
      })

  },

  /**
   * PUT the MP3 blob to S3 using the presigned URL.
   * Keep using fetch so only Content-Type is sent (matches the signature).
   * Returns { etag } when available.
   */
  async uploadAudioToS3(uploadURL, blob, contentType = 'audio/mpeg') {
    const putResp = await fetch(uploadURL, {
      method: 'PUT',
      headers: { 'Content-Type': contentType },
      body: blob,
    });
    if (!putResp.ok) {
      throw new Error(`S3 upload failed (${putResp.status})`);
    }
    const et =
      putResp.headers.get('ETag') ||
      putResp.headers.get('etag') ||
      null;

    return { etag: et ? et.replace(/"/g, '') : null };
  },

  /**
   * Convenience orchestrator: get URL → upload → start job.
   * Returns { jobName, etag }
   */
  async uploadAndStartTranscript(patientId, blob) {
    const { uploadURL, jobName } = await this.getUploadUrl(patientId);
    const { etag } = await this.uploadAudioToS3(uploadURL, blob);
    await this.startMedicalScribeJob(patientId, jobName);
    return { jobName, etag };
  },


  getTranscripts(reqObj, patientId){

    let url = AppSetting.transcripts.getAllTranscripts
    .replace('{providerId}', this.getLoggedInData()['parentId']) 
    .replace('{patientId}', patientId) 
    + this.buildQuery(reqObj);

    return axios.get(url)
      .then(res => { 
        return res.data 
      })
      .catch(err =>{
        return err
      });

  },

  addTranscript(reqObj){

    let providerId = this.getLoggedInData()['parentId'];

    let url = AppSetting.transcripts.addTranscript
    .replace('{providerId}', providerId);

    return axios.post(url, reqObj)
      .then(res => { 
        return res 
      })
      .catch(err =>{
        return err
      });

  },

  updateTranscriptHTML(reqObj){

    let providerId = this.getLoggedInData()['parentId'];

    let url = AppSetting.transcripts.updateTranscriptHTML
    .replace('{providerId}', providerId);

    return axios.put(url, reqObj)
      .then(res => { 
        return res 
      })
      .catch(err =>{
        return err
      });

  },

  buildQuery(data) {
    let queryData = "";
    for (const prop in data) {
      if (
        data[prop] !== "" &&
        data[prop] !== "undefined" &&
        data[prop] !== null
      ) {
        if (queryData === "") {
          queryData = "?" + prop + "=" + data[prop];
        } else {
          queryData += "&" + prop + "=" + data[prop];
        }
      }
    }
    return queryData;
  }
}

export default TranscriptsService